import { supabase, supabase_guest } from '../supabase/supabaseClient';

export const fetchDonationsByEvent = async (eventId, search = '') => {
  try {
    let query = supabase_guest
      .from('event_dana_payment')
      .select(`
        id,
        event_id,
        guest_id,
        amount,
        payment_status,
        proof_file,
        uploaded_at,
        uploaded_by,
        verified_at,
        verified_by,
        package_id
      `)
      .order('uploaded_at', { ascending: false });

    if (eventId) {
      query = query.eq('event_id', eventId);
    }

    const { data, error } = await query;

    if (error) {
      console.error('fetchDonationsByEvent error:', error);
      return [];
    }

    let donations = data || [];

    if (donations.length === 0) {
      const { data: authData, error: authError } = await supabase
        .from('event_dana_payment')
        .select(`
          id,
          event_id,
          guest_id,
          amount,
          payment_status,
          proof_file,
          uploaded_at,
          uploaded_by,
          verified_at,
          verified_by,
          package_id
        `)
        .order('uploaded_at', { ascending: false })
        .eq('event_id', eventId);

      if (authError) {
        console.error('fetchDonationsByEvent auth fallback error:', authError);
      } else {
        console.log('fetchDonationsByEvent auth fallback raw donations:', authData, 'eventId:', eventId);
        donations = authData || [];
      }
    }
    const guestIds = [...new Set(donations.map((item) => item.guest_id).filter(Boolean))];

    if (guestIds.length === 0) {
      return donations.map((item) => ({ ...item, guest: null }));
    }

    const { data: guestData, error: guestError } = await supabase_guest
      .from('guest')
      .select('id, name, phone_number')
      .in('id', guestIds);

    if (guestError) {
      console.error('fetchDonationsByEvent guest lookup error:', guestError);
      return donations.map((item) => ({ ...item, guest: null }));
    }

    const guestMap = (guestData || []).reduce((acc, guest) => {
      acc[guest.id] = guest;
      return acc;
    }, {});

    return donations.map((item) => ({
      ...item,
      guest: guestMap[item.guest_id] || null,
    }));
  } catch (err) {
    console.error('fetchDonationsByEvent error:', err);
    return [];
  }
};

export const approveDonation = async (donationId, verifier) => {
  const { data, error } = await supabase_guest
    .from('event_dana_payment')
    .update({
      payment_status: true,
      verified_at: new Date().toISOString(),
      verified_by: verifier,
    })
    .eq('id', donationId)
    .select();

  if (error) {
    console.error('approveDonation error:', error);
    throw error;
  }

  return data;
};

export const uploadProofFile = async (filePath, file) => {
  const { data, error } = await supabase_guest.storage
    .from('uploads')
    .upload(filePath, file, {
      cacheControl: '3600',
      upsert: false,
      contentType: file.type || 'application/octet-stream',
    });

  if (error) {
    console.error('uploadProofFile error:', error);
    throw error;
  }

  return data;
};

export const uploadDonationProof = async (donationId, proofUrl, uploader) => {
  const { data, error } = await supabase_guest
    .from('event_dana_payment')
    .update({
      proof_file: proofUrl,
      uploaded_at: new Date().toISOString(),
      uploaded_by: uploader,
      payment_status: false,
    })
    .eq('id', donationId)
    .select();

  if (error) {
    console.error('uploadDonationProof error:', error);
    throw error;
  }

  return data;
};

export const fetchProofUrl = async (objectName) => {
  if (!objectName) return null;

  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;

  return `${supabaseUrl}/functions/v1/download-r2?objectName=${encodeURIComponent(
    objectName
  )}`;
};

export const fetchEventList = async () => {
  const { data, error } = await supabase_guest
    .from('event')
    .select('id, name')
    .order('name', { ascending: true });

  if (error) {
    console.error('fetchEventList error:', error);
    return [];
  }

  return data || [];
};
